import * as React from "react";
import { IconProps } from "../types";

const ArrowsRefreshIcon = React.forwardRef<SVGSVGElement, IconProps>(
  ({ color = "currentColor", ...props }, forwardedRef) => {
    return (
      <svg
        width="19"
        height="18"
        fill="none"
        viewBox="0 0 19 18"
        xmlns="http://www.w3.org/2000/svg"
        ref={forwardedRef}
        {...props}
      >
        <path
          d="M9 12.75L11.25 15L9 17.25"
          stroke={color}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M5.452 4.238C4.105 5.384 3.25 7.093 3.25 9C3.25 12.452 6.048 15.25 9.5 15.25C10.079 15.25 10.64 15.171 11.172 15.024"
          stroke={color}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M10 5.25L7.75 3L10 0.75"
          stroke={color}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M13.548 13.762C14.895 12.616 15.75 10.907 15.75 9C15.75 5.548 12.952 2.75 9.5 2.75C8.903 2.75 8.325 2.834 7.778 2.99"
          stroke={color}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    );
  },
);

export default ArrowsRefreshIcon;
